import { HttpParamsObject } from '../../services/api/api.service';
import { DataFhirModel } from '../data.model';
import { DataFhirService } from '../data-fhir.service';
import { Provider, ProviderSearchParams } from './base-provider.model';
import { Observable } from 'rxjs';

export abstract class BaseProvidersService<
  Model extends DataFhirModel & Provider = DataFhirModel & Provider,
> extends DataFhirService<Model> {
  get defaultParamsObject(): HttpParamsObject {
    return {};
  }

  protected abstract processProviderSearchParams(
    params: ProviderSearchParams,
  ): HttpParamsObject;

  fetchDataByParams(params: ProviderSearchParams): void {
    this.fetchData(this.processProviderSearchParams(params));
  }

  searchDataByParams$(params: ProviderSearchParams): Observable<Model[]> {
    return this.searchItems$(this.processProviderSearchParams(params));
  }
}
